import { get, post } from '@/fn/ajax'
import { ListType } from '@/util/types'
import { walkTree } from '@/fn/tree'





// 获取设备列表
export async function getDeviceList() {
    // const classId = localStorage.classId
    const clientGroupId = localStorage.clientGroupId
    const query = clientGroupId ? { client_group_id: clientGroupId } : {}
    const data = await get('/api/play/client_status', query)
        .then(res => {
            return res
        })
    return data
}
export async function fetchClassList() {
    const { data } = await get('/api/classes/alist')
    const list = data.class_list || []
    return list
}

export async function fetchClientStatus() {
    const classId = localStorage.classId
    const clientGroupId = localStorage.clientGroupId
    const query: any = {}
    classId && (query.class_id = classId)
    clientGroupId && (query.client_group_id = clientGroupId)
    const { data } = await get('/api/play/client_view_status', query)
    return {
        ...data,
        onlineList: data.list.filter((it: any) => it.is_online == 1)
    }
}
export async function fetchList() {
    try {
        const data = await fetchClientStatus()
        return data
    } catch (ex) {
        //   message.error(String(ex))
    }
}
export async function fetchInstallStatus(id: any) {
    const query: any = { rid: id }
    const clientGroupId = localStorage.clientGroupId
    clientGroupId && (query.client_group_id = clientGroupId)
    const { data } = await get('/api/play/client_install_status', query)
    return {
        installedList: data.installed || [],
        installingList: data.installing || [],
        uninstalledList: data.uninstalled || [],
        failedList: data.install_failed || []
    }
}


export async function getMyPlayList() {
    const res = await get('/api/course/list_json')
    return res
}

export async function saveList(data: any) {
    const res = await post('/api/course/edit_json', data)
    return res
}

export async function switchMode(ids: any, free: boolean) {
    const mode = free ? 'toCommand' : 'toFree'
    const pdata = { ids, mode }
    await post('/api/play/mode_json', pdata)
}

export async function syncPlayTime(ids: any, resId: any, playIsPause: boolean) {
    const time = localStorage.video_gettime
    const pdata: any = {
        resId,
        time,
        ids
    }
    playIsPause && (pdata.status = 'pause')
    await post('/api/play/sync_play_time', pdata)
}

